<template>
	<div class="checkout-payment-section">

		<div id="form-container" class="row">
			<div class="col-xs-12">
				<ux-form-field label="Credit Card Number" :error="cardErrors.cardNumber">
					<div id="sq-card-number"></div>
				</ux-form-field>
			</div>

			<div class="col-md-6">
				<ux-form-field label="Expiry Date" :error="cardErrors.expirationDate">
					<div id="sq-expiration-date"></div>
				</ux-form-field>
			</div>

			<div class="col-md-6">
				<ux-form-field label="Security Code" :error="cardErrors.cvv">
					<div id="sq-cvv"></div>
				</ux-form-field>
			</div>
		</div> 

	</div>
</template>

<script>
import config from 'frontend/config';

export default {
	data() {
		return {
			cardErrors: {
				cardNumber: null,
				cvv: null,
				expirationDate: null,
			}
		}
	},

	methods: {
		initForm()
		{
			this.paymentForm = new SqPaymentForm({
				inputClass: 'ux-control',
				applicationId: config.squareAppId,
				autoBuild: false,
				postalCode: false,

				inputStyles: [{
					//fontFamily: 'monospace',
					fontSize: '16px',
					padding: '10px 0 0 0',
				}],

				cardNumber: { 
					elementId: 'sq-card-number', 
					placeholder: 'Credit card number' 
				},

				cvv: { 
					elementId: 'sq-cvv', 
					placeholder: 'Security code' 
				},

				expirationDate: { 
					elementId: 'sq-expiration-date', 
					placeholder: 'MM/YY' 
				},

				callbacks: {
					cardNonceResponseReceived: (errors, nonce, cardData) => {
						if (errors)
						{
							//var err = new Error('Square payment error');
							//err.squareErrors = errors;
							//this.onNonceFailed(err);
							this.updateCardErrors(errors);
						}	
						else
						{
							this.onNonceSuccess(nonce);
						}
					},
				}
			});
			this.paymentForm.build();
		},

		getNonce()
		{
			this.promise = new Promise((resolve, reject) => {
				this.onNonceSuccess = resolve;
				this.onNonceFailed = reject;
			});

			this.paymentForm.requestCardNonce();

			return this.promise;
		},

		updateCardErrors(errors)
		{
			this.cardErrors = {
				cardNumber: null,
				cvv: null,
				expirationDate: null,
			};

			console.log(errors);

			for(var err of errors)
				if (err.type == 'VALIDATION_ERROR' && err.field)
					this.$set(this.cardErrors, err.field, err.message);
		}
	},

	mounted()
	{
		this.initForm();
	},

	beforeDestroy()
	{
		this.paymentForm.destroy();
	}
}
</script>